@if (copyText && (!employeeOnly || userManagementService.isCmEmployee())) {
  <cm-button
    (click)="copyToClipboard()"
    [attr.data-icon]="isCopyClicked ? 'check' : 'duplicate'"
    [attr.data-label]="('General.Copy' | trans) + ' ' + (label | trans)"
    data-button-style="primary"
    data-button-type="icon-text"
    data-button-size="small">
  </cm-button>
}
